import { Reorder } from "framer-motion"
import { ClassNameValue } from "tailwind-merge"
import { DragHandleDots1Icon } from "@radix-ui/react-icons"
import clsx from "clsx"

interface Props {
  item: string
  className: ClassNameValue
}

export const Item = ({ item, className }: Props) => {
  return (
    <Reorder.Item
      as="div"
      value={item}
      id={item}
      // Reorder.Item owns the `y` transform while dragging — do not pass a
      // separate `y` MotionValue here or drag breaks (it overrides layout).
      whileDrag={{
        scale: 1.02,
        boxShadow: "5px 5px 10px rgba(0,0,0,0.25)",
      }}
      className={clsx(
        className,
        "relative flex cursor-grab select-none justify-between rounded-md border-2 border-gray-300 px-2 py-2 text-lg shadow-sm active:cursor-grabbing",
      )}
    >
      <span>{item}</span>
      <DragHandleDots1Icon className="size-6 shrink-0" aria-hidden />
    </Reorder.Item>
  )
}
